import type { StoryblokConfigSlug } from '~/types/storyblokConfigSlug';
import { LOCALES } from '~/i18n/locales';

export function findSectionConfigForStoryPath(
    registry: StoryblokConfigSlug[] | null | undefined,
    storyPath: string
): StoryblokConfigSlug | null {
    const [firstSegment, secondSegment, ...remainingSegments] = storyPath.replace(/^\/+|\/+$/g, '').split('/');
    const isCountry = registry?.some((config) => config.country === firstSegment) ?? false;
    const isLanguagePrefixedCountry =
        LOCALES.some((locale) => locale.code === firstSegment) &&
        (registry?.some((config) => config.country === secondSegment) ?? false);
    const country = isLanguagePrefixedCountry && !isCountry ? secondSegment : firstSegment;
    const storySegments =
        isLanguagePrefixedCountry && !isCountry ? remainingSegments : [secondSegment, ...remainingSegments];
    if (!country) return null;

    const contentPath = storySegments.filter(Boolean).join('/');
    return (
        registry
            ?.filter((config) => config.country === country)
            .filter(
                (config) => !config.slug || contentPath === config.slug || contentPath.startsWith(`${config.slug}/`)
            )
            .sort((a, b) => b.slug.split('/').filter(Boolean).length - a.slug.split('/').filter(Boolean).length)[0] ??
        null
    );
}
